import { render, staticRenderFns } from "./IntangibleLevel.vue?vue&type=template&id=aa453c56&"
import script from "./IntangibleLevel.vue?vue&type=script&lang=js&"
export * from "./IntangibleLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports